import { render, staticRenderFns } from "./v-checkbox.vue?vue&type=template&id=3565dcbc&scoped=true"
import script from "./v-checkbox.vue?vue&type=script&lang=js"
export * from "./v-checkbox.vue?vue&type=script&lang=js"
import style0 from "./v-checkbox.vue?vue&type=style&index=0&id=3565dcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___3aa45358577dd566fcc66441f4bfb966/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565dcbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCheckboxCheck: require('/opt/atlassian/pipelines/agent/build/components/icons/icon-checkbox-check.vue').default})
